import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsFacade, SharedFacade, customEncode } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridMyProjectImageComponent } from 'libs/ui/src/lib/grid-my-project-image/grid-my-project-image.component';
import { GridProjectLinkComponent } from 'libs/ui/src/lib/grid-project-link/grid-project-link.component';
import { ProjectsDataGridService } from '../projects-data-grid.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CustomModalService, productSubMenu } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-product-projects',
  templateUrl: './product-projects.component.html',
  styleUrls: ['./product-projects.component.css'],
})
export class ProductProjectsComponent {
  columnDefsForProductPackage!: ColDef[];
  activatedRoute: any;
  countryList: any;
  productProjectPayload: any;
  searchData: any = '';
  sortColumnState: any;
  productProjects: any;
  gridNameProductProject = 'Product project';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridMyProjectImageComponent: GridMyProjectImageComponent,
    GridProjectLinkComponent: GridProjectLinkComponent,
  };
  deleteProductProjectData: Subscription;
  createAccess = true;
  hideUnhideFunProduct!: Subscription;
  copyProductConfiguration!: Subscription;
  userRole: string = '';

  constructor(
    public projectFacde: ProjectsFacade,
    public sharedFacade: SharedFacade,
    private projectsDataGridService: ProjectsDataGridService,
    public route: ActivatedRoute,
    private projectsService: ProjectsService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private modal: CustomModalService,
    private router: Router,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const userRole = this.cookieService.get('u_type');
    this.userRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
    this.columnDefsForProductPackage = this.projectsDataGridService.getProductProjectsTabDataColumn(
      this.activatedRoute,
      this.userRole
    );
    this.createAccess = this.projectsDataGridService.isProjectAccess(
      this.activatedRoute,
      productSubMenu
    )
      ? this.projectsDataGridService.isProjectAccess(this.activatedRoute, productSubMenu)?.isCreate
      : true;
    this.getProductProjects();
    this.deleteProductProjectData =
      this.projectsDataGridService.deleteProductProjectData$.subscribe((deleteData: any) => {
        this.deleteProductProject(deleteData[0]);
      });

    this.copyProductConfiguration =
      this.projectsDataGridService.copyProductConfigurationData$.subscribe(async (data: any) => {
        this.copyProductConfigurationFunc(data);
      });
  }

  async copyProductConfigurationFunc(data: any) {
    const res = await this.projectsService.getProductConfigurationDataForCopy(data.productConfigId);
    this.modal.invoke('AddMainProductConfigurationComponent', {
      initialState: {
        productData: res?.data,
        isProductConfig: true,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.copyProductConfiguration.subscribe((data: any) => {
      this.saveCopyProductConfiguration(data);
    });
  }

  saveCopyProductConfiguration(data: any) {
    this.projectsService
      .copyProductConfiguration(data.payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProductProjects();
        })
      )
      .subscribe(res => {
        localStorage.setItem('productConfigId', res.data);
        this.router.navigate([
          `projects/product-configuration/${customEncode(btoa(res.data))}/setting`,
        ]);
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async addNewProductProject(productConfigId: any, label: any) {
    let response = await this.projectsService.getMyAllProductProjectModalEditData(
      productConfigId,
      false,
      0
    );
    this.modal.invoke('newMyProductProjects', {
      initialState: {
        newMyProductProjects: response.data,
        pathName: this.activatedRoute,
        label: label,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProductProjectEvent.subscribe(
      (saveNewMyProductProjectEvent: any) => {
        this.addProductProject(saveNewMyProductProjectEvent);
      }
    );
  }

  getProductProjects() {
    if (this.activatedRoute == 'admin-projects') {
      this.projectsService.GetAllProductContentListAdmin().subscribe((res: any) => {
        this.productProjects = res.data;
      });
    } else {
      this.projectsService.getMyAllProductProjectList().subscribe((res: any) => {
        this.productProjects = res.data;
      });
    }
  }

  ngOnInit(): void {
    this.sharedFacade.getCountryList();
    this.sharedFacade.countryList$.subscribe(data => {
      this.countryList = data;
    });

    this.hideUnhideFunProduct = this.projectsDataGridService.hideUnhideFunProduct$.subscribe(
      (data: any) => {
        this.hideUnhideProductData(data);
      }
    );
  }
  hideUnhideProductData(data: any) {
    this.projectsService
      .UpdateProductVisibility(data.productId, !data.isVisible)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        if (res.messageType && data) {
          this.toaster.error(res.message);
        } else {
          this.toaster.success(res.message);
          this.getProductProjects();
        }
      });
  }

  deleteProductProject(data: any) {
    this.projectsService
      .deleteProductConfigurationProject(data.productConfigId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProductProjects();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  addProductProject(data: any) {
    this.projectsService
      .saveProjectProduct(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getProductProjects();
        })
      )
      .subscribe(res => {
        localStorage.setItem('productConfigId', res.data);
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        if (
          this.projectsDataGridService.isAccess(this.activatedRoute).isView ||
          this.projectsDataGridService.isAccess(this.activatedRoute).isEdit
        ) {
          const encodedValue = encodeURIComponent(res.data);
          this.router.navigate([
            `projects/product-configuration/${customEncode(btoa(encodedValue))}/setting`,
          ]);
        }
      });
  }

  ngOnDestroy() {
    this.deleteProductProjectData.unsubscribe();
    this.hideUnhideFunProduct.unsubscribe();
    this.copyProductConfiguration.unsubscribe();
  }
}
